import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import PurchaseService, { PaymentStatus } from '../services/PurchaseService';

const initialState = {
  data: null,
  datas: [],
  purchaseStatuses: [],
  paymentMethods: [],
  formError: [],
  paymentStatuses: [],
  pagination: {
    page: 0,
    per_page: 10,
    total: 10,
    totalPages: 10,
  },
  error: null,
  status: '',
  loading: false,
  submitLoading: false,
  grand_total: 0,
  purchaseProducts: [],
  productsLoading: false,
};

export const purchaseList = createAsyncThunk(
  'purchase/list',
  async (payload) => {
    try {
      const resp = await PurchaseService.List(payload);
      return resp;
    } catch (e) {
      return e.response;
    }
  },
);

export const purchaseAdd = createAsyncThunk('purchase/add', async ({ data, navigate }) => {
  try {
    const resp = await PurchaseService.Create(data);
    if (resp?.status === 200) {
      const id = resp.data?.data?.id || resp.data?.id;
      if (id) {
        navigate(`/purchases/${id}`);
      } else {
        navigate('/purchases');
      }
    }
    return resp;
  } catch (e) {
    return e.response;
  }
});

export const purchaseEdit = createAsyncThunk('purchase/edit', async ({ id, data, navigate }) => {
  try {
    const resp = await PurchaseService.Put(id, data);
    if (resp?.status === 200) {
      navigate(`/purchases/${id}`);
    }
    return resp;
  } catch (e) {
    return e.response;
  }
});

export const purchaseDelt = createAsyncThunk('purchase/delt', async (id) => {
  try {
    const resp = await PurchaseService.Delt(id);

    return resp;
  } catch (e) {
    return e.response;
  }
});

export const getPurchaseStatus = createAsyncThunk('purchase/purchase-status', async () => {
  try {
    const resp = await PurchaseService.PurchaseStatus();
    return resp;
  } catch (error) {
    return error.response;
  }
});

export const getPaymentMethod = createAsyncThunk('purchase/payment-method', async () => {
  try {
    const resp = await PurchaseService.PaymentMethod();
    return resp;
  } catch (error) {
    return error.response;
  }
});

export const getPurchaseDetail = createAsyncThunk('purchase/detail', async ({ id }) => {
  try {
    const resp = await PurchaseService.Detail(id);
    return resp;
  } catch (error) {
    return error.response;
  }
});

export const getPaymentStatus = createAsyncThunk('/purchase/payment-status', async () => {
  try {
    const response = await PurchaseService.PaymentStatus();
    return response;
  } catch (error) {
    return error.response
  }
});

export const purchaseUpdateStatus = createAsyncThunk('purchase/update-status', async ({ id, status }, { rejectWithValue }) => {
  try {
    const resp = await PurchaseService.UpdateStatus(id, { status });
    return resp;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

export const purchaseReverseReceipt = createAsyncThunk('purchase/reverse-receipt', async ({ id, reason }, { rejectWithValue }) => {
  try {
    const resp = await PurchaseService.ReverseReceipt(id, { reason });
    return resp;
  } catch (error) {
    return rejectWithValue(error.response?.data || { message: 'Failed to reverse receipt' });
  }
});

export const getPurchaseProducts = createAsyncThunk('purchase/products', async (params = {}) => {
  try {
    const resp = await PurchaseService.Products(params);
    return resp;
  } catch (error) {
    return error.response;
  }
});

const purchaseAction = createSlice({

  name: 'purchase',
  initialState: initialState,
  extraReducers: (builder) => {
    builder
      .addCase(purchaseList.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(purchaseList.fulfilled, (state, action) => {
        if (action.payload?.status === 200) {

          state.datas = [...action.payload?.data?.data?.purchases];
          state.pagination = action.payload?.data?.data?.pagination;
          state.grand_total = action.payload?.data?.data?.grand_total || 0;
        } else {
          state.error = action.payload?.data.message;
          toast.error(state.error);
        }
        state.loading = false;
      })
      .addCase(purchaseList.rejected, (state, action) => {
        state.error = action.payload?.data;
        state.loading = false;
      })
      .addCase(purchaseAdd.pending, (state, action) => {
        state.submitLoading = true;
      })
      .addCase(purchaseAdd.fulfilled, (state, action) => {
        state.status = '';
        if (action.payload?.status === 200) {
          // state.datas.unshift(action.payload?.data?.data?.purchase);
          state.info = action.payload?.data.message;
          state.status = 'achieve';
          toast.success(action.payload?.data.message);
        } else {
          toast.error(action.payload?.data.message);
        }
        state.formError = action.payload?.data.errors;
        state.submitLoading = false;
      })
      .addCase(purchaseAdd.rejected, (state, action) => {
        state.error = action.payload?.data;
        state.submitLoading = false;
      })
      .addCase(purchaseEdit.pending, (state, action) => {
        state.info = '';
        state.submitLoading = true;
      })
      .addCase(purchaseEdit.fulfilled, (state, action) => {
        if (action.payload?.status === 200) {
          state.info = action.payload?.data.message;
          // const index = state.datas.findIndex(
          //   (client) => client.id === action.payload.data?.data?.purchase?.id,
          // );
          // state.datas[index] = {
          //   ...state[index],
          //   ...action.payload.data?.data?.purchase,
          // };
          toast.success(action.payload?.data.message);
        } else {
          toast.error(action.payload?.data.message);
        }
        state.formError = action.payload?.data.errors;
        state.submitLoading = false;
      })
      .addCase(purchaseEdit.rejected, (state, action) => {
        state.error = action.payload?.data;
        state.submitLoading = false;
      })
      .addCase(purchaseDelt.pending, (state, action) => {
        state.info = '';
        state.submitLoading = true;
      })
      .addCase(purchaseDelt.fulfilled, (state, action) => {

        if (action.payload?.status === 200) {
          let index = state.datas.findIndex(({ id }) => id === action.payload.data?.data?.purchase?.id);
          state.datas.splice(index, 1);
          state.info = action.payload?.data.message;
          toast.success(action.payload?.data.message);
        }
        state.submitLoading = false;
      })
      .addCase(purchaseDelt.rejected, (state, action) => {
        state.error = action.payload?.data;
        state.submitLoading = false;
      })
      .addCase(getPurchaseStatus.pending, (state, action) => {
        state.info = '';
        state.loading = true;
      })
      .addCase(getPurchaseStatus.fulfilled, (state, action) => {
        if (action.payload?.status === 200) {
          state.purchaseStatuses = [...action.payload?.data?.data];
        } else {
          state.error = action.payload?.data.message;
          toast.error(state.error);
        }
        state.loading = false;
      })
      .addCase(getPurchaseStatus.rejected, (state, action) => {
        state.error = action.payload?.data;
        state.loading = false;
      })
      .addCase(getPaymentMethod.pending, (state, action) => {
        state.info = '';
        state.loading = true;
      })
      .addCase(getPaymentMethod.fulfilled, (state, action) => {
        if (action.payload?.status === 200) {
          state.paymentMethods = [...action.payload?.data?.data];
        } else {
          state.error = action.payload?.data.message;
          toast.error(state.error);
        }
        state.loading = false;
      })
      .addCase(getPaymentMethod.rejected, (state, action) => {
        state.error = action.payload?.data;
        state.loading = false;
      })
      .addCase(getPurchaseDetail.pending, (state, action) => {
        state.info = '';
        state.submitLoading = true;
      })
      .addCase(getPurchaseDetail.fulfilled, (state, action) => {
        if (action.payload?.status === 200) {
          state.info = action.payload?.data?.data.message;
          state.data = action.payload?.data?.data
          // toast.success(action.payload?.data.message);
        } else {
          toast.error(action.payload?.data.message);
        }
        state.formError = action.payload?.data.errors;
        state.submitLoading = false;
      })
      .addCase(getPurchaseDetail.rejected, (state, action) => {
        state.error = action.payload?.data;
        state.submitLoading = false;
      })
      .addCase(getPaymentStatus.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getPaymentStatus.fulfilled, (state, action) => {
        if (action.payload?.status === 200) {
          state.paymentStatuses = [...action.payload?.data?.data];
        } else {
          state.error = action.payload?.data.message;
          toast.error(state.error);
        }
        state.loading = false;
      })
      .addCase(getPaymentStatus.rejected, (state, action) => {
        state.error = action.payload?.data;
        state.submitLoading = false;
      })
      .addCase(purchaseUpdateStatus.pending, (state) => {
        state.submitLoading = true;
      })
      .addCase(purchaseUpdateStatus.fulfilled, (state, action) => {
        state.submitLoading = false;
        if (action.payload?.status === 200) {
          const updatedPurchase = action.payload.data?.data;

          // Update in single item detail if it matches
          if (state.data && state.data.id === updatedPurchase?.id) {
            state.data = {
              ...state.data,
              ...updatedPurchase
            };
          }

          // Update in list
          if (state.datas && state.datas.length > 0) {
            state.datas = state.datas.map((purchase) => {
              if (purchase.id === updatedPurchase?.id) {
                return {
                  ...purchase,
                  ...updatedPurchase
                };
              }
              return purchase;
            });
          }

          toast.success(action.payload?.data?.message || 'Status updated successfully');
        } else {
          toast.error(action.payload?.data?.message || 'Failed to update status');
        }
      })
      .addCase(purchaseUpdateStatus.rejected, (state, action) => {
        state.submitLoading = false;
        state.error = action.payload?.message || 'Something went wrong';
        toast.error(state.error);
      })
      .addCase(purchaseReverseReceipt.pending, (state) => {
        state.submitLoading = true;
      })
      .addCase(purchaseReverseReceipt.fulfilled, (state, action) => {
        state.submitLoading = false;
        if (action.payload?.status === 200) {
          const updatedPurchase = action.payload.data?.data?.purchase;
          if (state.data && updatedPurchase && state.data.id === updatedPurchase.id) {
            state.data = {
              ...state.data,
              ...updatedPurchase,
            };
          }
          if (state.datas && state.datas.length > 0 && updatedPurchase) {
            state.datas = state.datas.map((purchase) => {
              if (purchase.id === updatedPurchase.id) {
                return {
                  ...purchase,
                  ...updatedPurchase,
                };
              }
              return purchase;
            });
          }
          toast.success(action.payload?.data?.message || 'Purchase receipt reversed successfully.');
        } else {
          toast.error(action.payload?.data?.message || 'Failed to reverse receipt');
        }
      })
      .addCase(purchaseReverseReceipt.rejected, (state, action) => {
        state.submitLoading = false;
        state.error = action.payload?.message || 'Something went wrong';
        toast.error(state.error);
      })
      .addCase(getPurchaseProducts.pending, (state) => {
        state.productsLoading = true;
      })
      .addCase(getPurchaseProducts.fulfilled, (state, action) => {
        if (action.payload?.status === 200) {
          state.purchaseProducts = action.payload?.data?.data || [];
        } else {
          state.error = action.payload?.data?.message;
          toast.error(state.error);
        }
        state.productsLoading = false;
      })
      .addCase(getPurchaseProducts.rejected, (state, action) => {
        state.error = action.payload?.data;
        state.productsLoading = false;
      });
  },
});

const { reducer } = purchaseAction;

export const purchaseSelector = (state) => state.purchase;

export default reducer;
